import React, {useEffect, useState } from "react";
import {  getPublishedJobOpenings } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { alertError } from "../../utils/alerts";
import logo from "../../assets/img/humanely-white.png";

export default function PublishedJobOpenings() {
    const [loading, setLoading] = useState(true);
    const [jobs, setJobs] = useState(null);

    // useEffect(() => {
        localStorage.removeItem("kloka:token:data");
        localStorage.removeItem("kloka:type");
        localStorage.removeItem("kloka:role");
        localStorage.removeItem("kloka:categories");

        // alert('yes')
    // }, []); 

    useEffect(() => {
        getPublishedJobOpenings()
            .then((res) => {
                if(res.data.success){
                    setJobs(res.data.data);
                }else {
                    alertError(res.data.message);
                }
                setTimeout(() => {
                    setLoading(false)
                }, 4500);
            })
            .catch((err) => {
                console.log(err?.response?.data?.error)
            });
    
            setLoading(false);
    }, []); 

    return (
        <>  
            <section className="publicjobs">
                <div className="public">
                    <div className="layer">
                        <div className="text-center">
                            <img src={logo} className="" alt="logo" width={220} height={30} />
                        </div>

                        <div className="container">
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8 text-center">
                                    <h3>We are more than a workplace.</h3>
                                    <p>At Kimberly Ryan Limited we're dedicated to helping businesses like yours thrive in today's competitive landscape. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container" >
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h2>Current Openings</h2>
                        </div>
                        {(!loading && jobs && jobs.length > 0) ? <>
                            {jobs && jobs.map((item, index) => (
                                <div className="col-md-4 col-sm-6" key={index}>
                                    <div className="pubcard">
                                        <p>{item.jobType}</p>
                                        <h5><a href={`${item.jobUrl}`}>{item.jobTitle && item.jobTitle}</a></h5>
                                        <p>{item.location}</p>        
                                    </div>
                                </div>
                            ))}
                        </> : <Loader /> }
                    </div>
                </div>

                
            </section>

            <div className="publicjobsfooter">
                <p>Powered by Kimberly Ryan Limited</p>
            </div>
        </>
    );
}
